import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { ServiceCarpetStainRemoval } from 'src/app/shared/models/entities/service';

@Component({
  selector: 'laveo-select-service-carpet-stain-removal',
  templateUrl: './select-service-carpet-stain-removal.component.html',
  styleUrls: ['./select-service-carpet-stain-removal.component.scss']
})
export class SelectServiceCarpetStainRemovalComponent {
  @Input() control: AbstractControl | null;
  @Input() typeSize: 'default' | 'small' | 'large' = 'large';
  @Input() typeSelection: 'single' | 'multiple' = 'single';
  @Input() values: ServiceCarpetStainRemoval[] = Object.values(ServiceCarpetStainRemoval);

  public get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }
}
